export const reportsTranslations = {
  report_title: 7991,
  report_download_title: 7938,
  report_download_description: 7988,
  report_download_submit: 7936,
  report_download_cancel: 7935,
  report_no_data: 7992,
  report_sent_to: 8839
};

export const endpoint = {
  loadReportStatus: 'report/status',
  downloadReportPackage: 'report'
};

export const reportStatusPollingInterval = 5000;
